import { render } from "./LicView.vue?vue&type=template&id=23d2a8b8&scoped=true"
import script from "./LicView.vue?vue&type=script&lang=js"
export * from "./LicView.vue?vue&type=script&lang=js"

import "./LicView.vue?vue&type=style&index=0&id=23d2a8b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d2a8b8"]])

export default __exports__